/** Temporary display records do not define fields on the surrounding form's
 * relation. Providers enforce API access; containing tabs retain UI restrictions.
 */
function asDataDictionary() {
    return [{}, {}];
}

module.exports = { asDataDictionary };
